import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "./EventoFormField";
import formCadastroEvento from "../schemas/forms";
import { ChangeEvent } from "react";

const { formField } = formCadastroEvento;
const { infoRetiradaKit } = formField;

interface FieldDetailsProps {
  values: {
    [x: string]: string;
  };
  handleBlur: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  handleChange: {
    (e: ChangeEvent<any>): void;
    <T = string | ChangeEvent<any>>(
      field: T
    ): T extends ChangeEvent<any>
      ? void
      : (e: string | ChangeEvent<any>) => void;
  };
}

export default function FieldInfokits({
  values,
  handleBlur,
  handleChange,
}: FieldDetailsProps) {
  return (
    <Card id="info-kits" sx={{ overflow: "visible", margin: "10px 0" }}>
      <MDBox p={3} lineHeight={1}>
        <MDBox mb={1}>
          <MDTypography variant="h5">Informações sobre o kits</MDTypography>
        </MDBox>
      </MDBox>

      <MDBox pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <FormField
              type={infoRetiradaKit.type}
              label={infoRetiradaKit.label}
              name={infoRetiradaKit.name}
              // error={Boolean(touched.infoRetiradaKit && errors.infoRetiradaKit)}
              variant="outlined"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.infoRetiradaKit}
              multiline
              rows={2}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}
